import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/contacts')({
  component: () => <Outlet />,
})
